"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes2 = require("@agillic/prop-types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ProgressBar = function ProgressBar(_ref) {
  var color = _ref.color,
    isPending = _ref.isPending,
    isSmall = _ref.isSmall,
    percentage = _ref.percentage,
    completed = _ref.completed,
    total = _ref.total,
    tooltip = _ref.tooltip,
    isDisabled = _ref.isDisabled,
    uniqueID = _ref.uniqueID;
  var division = Math.min(Math.floor(completed / total * 100), 100);
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('agillicProgressBar', color, {
      pending: isPending,
      small: isSmall,
      disabled: isDisabled
    }),
    title: tooltip,
    "data-testid": uniqueID
  }, _react.default.createElement("div", {
    className: "bar"
  }, _react.default.createElement("div", {
    className: "progress",
    style: {
      width: percentage ? "".concat(percentage, "%") : "".concat(division, "%")
    }
  }), _react.default.createElement("span", null, percentage ? "".concat(percentage, "%") : "".concat(completed, " / ").concat(total))));
};
ProgressBar.propTypes = {
  percentage: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _airbnbPropTypes.between)({
    gte: 0,
    lte: 100
  }), (0, _propTypes2.forbiddenBy)('total'), (0, _propTypes2.forbiddenBy)('completed')]),
  color: (0, _propTypes.oneOf)(['grey', 'red', 'green', 'lightGreen', 'blue', 'orange', 'darkOrange', 'purple', 'yellow']).isRequired,
  isPending: _propTypes.bool,
  isDisabled: _propTypes.bool,
  isSmall: _propTypes.bool,
  total: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _propTypes2.greaterThan)('completed'), (0, _propTypes2.forbiddenBy)('percentage'), (0, _propTypes2.requiredBy)('completed')]),
  completed: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _propTypes2.forbiddenBy)('percentage'), (0, _propTypes2.requiredBy)('total')]),
  tooltip: _propTypes.string,
  uniqueID: _propTypes.string
};
ProgressBar.defaultProps = {
  color: 'grey'
};
var _default = ProgressBar;
exports.default = _default;